const PADDED_DECIMAL = /^(-?\d+\.\d{2,}?)0+$/;

export function twoPlaceMoney(value: string | null | undefined): string | null {
    if (value === null || value === undefined) return null;
    return PADDED_DECIMAL.exec(value)?.[1] ?? value;
}
